import axios from "axios";
import {
  fetchLMSStart,
  fetchLMSSuccess,
  fetchLMSFailure,
  updateLMSStart,
  updateLMSSuccess,
  updateLMSFailure,
  fetchStudentPortalStart,
  fetchStudentPortalSuccess,
  fetchStudentPortalFailure,
  updateStudentPortalStart,
  updateStudentPortalSuccess,
  updateStudentPortalFailure,
  fetchOfficeStart,
  fetchOfficeSuccess,
  fetchOfficeFailure,
  updateOfficeStart,
  updateOfficeSuccess,
  updateOfficeFailure,
  fetchOnlinePaymentStart,
  fetchOnlinePaymentSuccess,
  fetchOnlinePaymentFailure,
  updateOnlinePaymentStart,
  updateOnlinePaymentSuccess,
  updateOnlinePaymentFailure,
  fetchPasswordManagerStart,
  fetchPasswordManagerSuccess,
  fetchPasswordManagerFailure,
  updatePasswordManagerStart,
  updatePasswordManagerSuccess,
  updatePasswordManagerFailure,
  fetchHelpDeskStart,
  fetchHelpDeskSuccess,
  fetchHelpDeskFailure,
  updateHelpDeskStart,
  updateHelpDeskSuccess,
  updateHelpDeskFailure,
  fetchIMSStart,
  fetchIMSSuccess,
  fetchIMSFailure,
  updateIMSStart,
  updateIMSSuccess,
  updateIMSFailure
} from "../slicer/ITServicesSlice";

const getToken = () =>
  document.cookie
    .split("; ")
    .find((row) => row.startsWith("accessToken="))
    ?.split("=")[1];

// Helper function to get the auth headers
const getAuthHeaders = () => {
  const token = getToken();
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

export const fetchIMSData = () => async (dispatch) => {
  console.log("This is action");
  dispatch(fetchIMSStart()); // Set loading state
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/itServices/getIMS`,
      getAuthHeaders() // Added authentication headers
    );
    const data = response?.data?.data?.[0] || {}; // Safely access response data
    dispatch(fetchIMSSuccess(data)); // Dispatch success action with data
  } catch (error) {
    console.error("Error fetching IMS data:", error);
    dispatch(
      fetchIMSFailure(
        error.response?.data?.message || "Failed to fetch IMS data"
      )
    );
  }
};


export const updateIMSData = (id, introduction, url) => async (dispatch) => {
  dispatch(updateIMSStart()); // Start updating
  try {
    await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/itServices/updateIMS/${id}`,
      { introduction, url },
      getAuthHeaders() // Added authentication headers
    );
    dispatch(updateIMSSuccess({ introduction, url })); // Update state with new data
    alert("introduction and URL updated successfully!"); // Success alert
  } catch (error) {
    console.error("Error updating URL data:", error);
    dispatch(updateIMSFailure(error.message || "Something went wrong"));
    alert(
      `Error updating introduction and URL: ${
        error.message || "Something went wrong"
      }`
    ); // Error alert
  }
};
export const fetchLMSData = () => async (dispatch) => {
  console.log("This is action");
  dispatch(fetchLMSStart()); // Set loading state
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/itServices/getLLMS`,
      getAuthHeaders() // Added authentication headers
    );
    const data = response?.data?.data?.[0] || {}; // Safely access response data
    dispatch(fetchLMSSuccess(data)); // Dispatch success action with data
  } catch (error) {
    console.error("Error fetching LMS data:", error);
    dispatch(
      fetchLMSFailure(
        error.response?.data?.message || "Failed to fetch LMS data"
      )
    );
  }
};

export const updateLMSData = (id, introduction, url) => async (dispatch) => {
  dispatch(updateLMSStart()); // Start updating
  try {
    await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/itServices/updateLLMS/${id}`,
      { introduction, url },
      getAuthHeaders() // Added authentication headers
    );
    dispatch(updateLMSSuccess({ introduction, url })); // Update state with new data
    alert("introduction and URL updated successfully!"); // Success alert
  } catch (error) {
    console.error("Error updating URL data:", error);
    dispatch(updateLMSFailure(error.message || "Something went wrong"));
    alert(
      `Error updating introduction and URL: ${
        error.message || "Something went wrong"
      }`
    ); // Error alert
  }
};

export const fetchStudentPortalData = () => async (dispatch) => {
  console.log("This is action");
  dispatch(fetchStudentPortalStart()); // Set loading state
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/itServices/getStudentPortal`,
      getAuthHeaders() // Added authentication headers
    );
    const data = response?.data?.data?.[0] || {}; // Safely access response data
    dispatch(fetchStudentPortalSuccess(data)); // Dispatch success action with data
  } catch (error) {
    console.error("Error fetching StudentPortal data:", error);
    dispatch(
      fetchStudentPortalFailure(
        error.response?.data?.message || "Failed to fetch StudentPortal data"
      )
    );
  }
};

export const updateStudentPortalData =
  (id, introduction, url) => async (dispatch) => {
    dispatch(updateStudentPortalStart()); // Start updating
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/itServices/updateStudentPortal/${id}`,
        { introduction, url },
        getAuthHeaders() // Added authentication headers
      );
      dispatch(updateStudentPortalSuccess({ introduction, url })); // Update state with new data
      alert("introduction and URL updated successfully!"); // Success alert
    } catch (error) {
      console.error("Error updating URL data:", error);
      dispatch(
        updateStudentPortalFailure(error.message || "Something went wrong")
      );
      alert(
        `Error updating introduction and URL: ${
          error.message || "Something went wrong"
        }`
      ); // Error alert
    }
  };

export const fetchOfficeData = () => async (dispatch) => {
  console.log("This is action");
  dispatch(fetchOfficeStart()); // Set loading state
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/itServices/getOffice365`,
      getAuthHeaders() // Added authentication headers
    );
    const data = response?.data?.data?.[0] || {}; // Safely access response data
    dispatch(fetchOfficeSuccess(data)); // Dispatch success action with data
  } catch (error) {
    console.error("Error fetching Office data:", error); // Changed from StudentPortal to Office for clarity
    dispatch(
      fetchOfficeFailure(
        error.response?.data?.message || "Failed to fetch Office data" // Changed from StudentPortal to Office
      )
    );
  }
};

export const updateOfficeData = (id, introduction, url) => async (dispatch) => {
  dispatch(updateOfficeStart()); // Start updating
  try {
    await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/itServices/updateOffice365/${id}`,
      { introduction, url },
      getAuthHeaders() // Added authentication headers
    );
    dispatch(updateOfficeSuccess({ introduction, url })); // Update state with new data
    alert("introduction and URL updated successfully!"); // Success alert
  } catch (error) {
    console.error("Error updating URL data:", error);
    dispatch(updateOfficeFailure(error.message || "Something went wrong"));
    alert(
      `Error updating introduction and URL: ${
        error.message || "Something went wrong"
      }`
    ); // Error alert
  }
};

export const fetchOnlinePaymentData = () => async (dispatch) => {
  console.log("This is action");
  dispatch(fetchOnlinePaymentStart()); // Set loading state
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/itServices/getOnlinePayment`,
      getAuthHeaders() // Added authentication headers
    );
    const data = response?.data?.data?.[0] || {}; // Safely access response data
    dispatch(fetchOnlinePaymentSuccess(data)); // Dispatch success action with data
  } catch (error) {
    console.error("Error fetching Online Payment data:", error); // Changed from StudentPortal
    dispatch(
      fetchOnlinePaymentFailure(
        error.response?.data?.message || "Failed to fetch Online Payment data" // Changed from StudentPortal
      )
    );
  }
};

export const updateOnlinePaymentData =
  (id, introduction, url) => async (dispatch) => {
    dispatch(updateOnlinePaymentStart()); // Start updating
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/itServices/updateOnlinePayment/${id}`,
        { introduction, url },
        getAuthHeaders() // Added authentication headers
      );
      dispatch(updateOnlinePaymentSuccess({ introduction, url })); // Update state with new data
      alert("introduction and URL updated successfully!"); // Success alert
    } catch (error) {
      console.error("Error updating URL data:", error);
      dispatch(
        updateOnlinePaymentFailure(error.message || "Something went wrong")
      );
      alert(
        `Error updating introduction and URL: ${
          error.message || "Something went wrong"
        }`
      ); // Error alert
    }
  };

export const fetchPasswordManagerData = () => async (dispatch) => {
  console.log("This is action");
  dispatch(fetchPasswordManagerStart()); // Set loading state
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/itServices/getPasswordManagement`,
      getAuthHeaders() // Added authentication headers
    );
    console.log(response);
    const data = response?.data?.data?.[0] || {}; // Safely access response data

    dispatch(fetchPasswordManagerSuccess(data)); // Dispatch success action with data
  } catch (error) {
    console.error("Error fetching Password Manager data:", error);
    dispatch(
      fetchPasswordManagerFailure(
        error.response?.data?.message || "Failed to fetch Password Manager data" // Changed from StudentPortal
      )
    );
  }
};

export const updatePasswordManagerData =
  (id, introduction, url) => async (dispatch) => {
    dispatch(updatePasswordManagerStart());
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/itServices/updatePasswordManagement/${id}`,
        { introduction, url },
        getAuthHeaders() // Added authentication headers
      );
      dispatch(updatePasswordManagerSuccess({id, introduction, url })); // Update state with new data
      alert("introduction and URL updated successfully!"); // Success alert
    } catch (error) {
      console.error("Error updating URL data:", error);
      dispatch(
        updatePasswordManagerFailure(error.message || "Something went wrong")
      );
      alert(
        `Error updating introduction and URL: ${
          error.message || "Something went wrong"
        }`
      ); // Error alert
    }
  };




export const fetchHelpDeskData = () => async (dispatch) => {
  console.log("This is action");
  dispatch(fetchHelpDeskStart()); // Set loading state
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/itServices/getHelpDesk`,
      getAuthHeaders() // Added authentication headers
    );
    console.log(response);
    const data = response?.data?.data?.[0] || {}; // Safely access response data

    dispatch(fetchHelpDeskSuccess(data)); // Dispatch success action with data
  } catch (error) {
    console.error("Error fetching Help Desk data:", error);
    dispatch(
      fetchHelpDeskFailure(
        error.response?.data?.message || "Failed to fetch Help Desk data"
      )
    );
  }
};


export const updateHelpDeskData = (id, formData) => async (dispatch) => {
  dispatch(updateHelpDeskStart());
  try {
    const token = getToken();
    const headers = {
      "Content-Type": "multipart/form-data", // This must be set for file uploads
    };
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    const response = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/itServices/updateHelpDesk/${id}`,
      formData, // FormData
      { headers } // Passed the combined headers object
    );

    dispatch(updateHelpDeskSuccess(response.data));
    alert("Help Desk updated successfully!");
    
  } catch (error) {
    console.error("Error updating Help Desk:", error.response || error);
    dispatch(
      updateHelpDeskFailure(
        error.response?.data?.message || "Error updating Help Desk "
      )
    );
    alert(
      `Error updating Help Desk : ${
        error.response?.data?.message || "Something went wrong"
      }`
    );
  }
};